<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <card-divider-header></card-divider-header>
        <v-flex class="text-xs-right">
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-menu
              slot="activator"
              bottom
              left
              transition="scale-transition"
              max-height="600px"
              origin="top right"
              :close-on-content-click="false"
              v-model="fieldChooserMenu"
            >
              <v-btn flat icon color="grey" slot="activator">
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                  <v-list-tile-action>
                    <v-checkbox
                      :color="$store.state.global.pages.allocation.color"
                      v-model="defaultHeaders"
                      :label="header.text"
                      :value="header.value"
                    ></v-checkbox>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-menu>
            <span>Add & Remove Columns</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table :items="lines" :headers="headers" :loading="loading" disable-initial-sort>
      <template slot="no-data">
        <div class="text-xs-center grey--text subheading">No lines for the selected criteria.</div>
      </template>

      <template slot="items" slot-scope="props">
        <line-row
          :line="props.item"
          :batch="batch"
          :headers="headers"
          :key="props.item.id+props.item.updatedAt"
          :ref="props.item.id"
        ></line-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'
import FormatDates from '@/services/mixins/formatDates'
import LineViewMixin from './mixins/lineViewMixin'
import HeaderFilters from '@/services/mixins/headerFilters'
import LineRow from './lineRow'
export default {
  mixins: [FormatDates, LineViewMixin, HeaderFilters],
  props: {
    batch: Object,
  },
  data() {
    return {
      lines: [],
      loading: false,
      fieldChooserMenu: false,
    }
  },
  methods: {
    getLines() {
      AllocationService.getBatchLines(this.batch)
        .then((result) => {
          this.lines = result.data.result
        })
        .catch((err) => {
          console.log(err)
          this.snackError()
        })
    },
  },
  components: {
    LineRow,
  },
  mounted() {
    this.getLines()
  },
  computed: {
    //fetchLines: Store.getSet({store: 'allocationStaging', prop: 'fetchLines'})
  },
  watch: {
    // fetchLines() {
    //     this.getLines()
    // },
    batch: {
      deep: true,
      handler(val) {
        this.getLines()
      },
    },
  },
}
</script>